import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-background-50 whitespace-nowrap cursor-pointer">
              Kakobuy<span className="text-primary-400">Finds</span>
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              Your trusted resource for the best Kakobuy Spreadsheet, product finds, and shopping guides. Updated regularly for smart product discovery.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              <a href="#categories" className="hover:text-primary-400 transition-colors cursor-pointer">Categories</a>
            </h4>
            <ul className="space-y-2">
              {['Shoes', 'Hoodies & Sweaters', 'T-Shirts', 'Jackets', 'Bags', 'Accessories', 'Headwear', 'Perfumes'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#categories"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">Articles</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/kakobuy-spreadsheet-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-vs-cssbuy-spreadsheet" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  Kakobuy vs CSSBuy
                </Link>
              </li>
              <li>
                <Link to="/category-guide-shoes" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  Shoes Category Guide
                </Link>
              </li>
              <li>
                <Link to="/complete-safety-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  Complete Safety Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                >
                  Kakobuy Sheet
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                >
                  Buy It Now
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                >
                  Main Website
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} KakobuyFinds. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="/" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="/" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer">Terms</a>
            <a href="/" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}